import React, { useEffect, useState } from 'react';
import globalIP from '@/GlobelIP';
import { Button, Divider, Modal, Nav, Panel, PanelGroup, Stack, Toggle } from 'rsuite';
import ErrorPage from '@/components/ErrorPage';

const YourModal = ({ onClose, data }) => {
  const ip = globalIP;
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [activeKey, setActiveKey] = useState('content1');
  const handleNavSelect = eventKey => {
    setActiveKey(eventKey);
  };
  const [activeKey1, setActiveKey1] = useState('');

  const handleNavSelect1 = eventKey => {
    setActiveKey1(eventKey);
  };
  const [status, setStatus] = useState({
    MProduct: false,
    MCatalogue: false,
    MCollection: false,
    MEmarketing: false,
    MQuotation: false,
    MBuyer: false,
    PMaster: false,
    MSTCategory: false,
    MSTPType: false,
    MSTCollection: false,
    MSTFinish: false,
    MSTColor: false,
    MSTHSN: false,
    MSTShape: false,
    MSTPTechnique: false,
    MSTProcess: false,
    MSTMaterial: false,
    PRDView: false,
    PRDAdd: false,
    PRDManage: false,
    PRDEdit: false,
    PRDDelete: false,
    PRDpicdwnld: false,
    CATcreate: false,
    CATupdate: false,
    CATaccessPPT: false,
    CATLinkSecurity: false,
    CATShwPrice: false,
    CATCustomizeTab: false,
    CATModifySts: false,
    CATBuyerAct: false,
    CATControlSet: false,
    CATDelete: false,
    MSpaceV: false,
    MFair: false,
    MEnquiry: false,
    MGreeting: false,
    PriceList: false,
    MSTSeason: false,
    MSTCosHead: false,
    MSTCurrency: false,
    MSTComponent: false,
    PRDCostShow: false,
    Authorised: false
  });
useEffect(() => {
  if (activeKey !== 'content2') return; // only run when we're in content2 tab

  const keysToCheck = [
    'MProduct',
    'MCatalogue',
    'MCollection',
    'MEmarketing',
    'MQuotation',
    'MBuyer',
    'PMaster'
  ];

  const tabMap = {
    MProduct: 'sub1',
    MCatalogue: 'sub2',
    MCollection: 'sub3',
    MEmarketing: 'sub4',
    MQuotation: 'sub5',
    MBuyer: 'sub6',
    PMaster: 'sub7'
  };

  const firstTrueKey = keysToCheck.find(key => status[key] === true);

  if (firstTrueKey) {
    setActiveKey1(tabMap[firstTrueKey]);
  } else {
    setActiveKey1(''); // none enabled
  }
}, [activeKey]);


  useEffect(() => {
    if (data) {
      fetchData();
    }
  }, [data]);
  const fetchData = async () => {
    try {
      const response = await fetch(`${ip}/api/user-details/${data}?populate=*`);
      const json = await response.json();
      const extractedData = json.data.attributes;
      setStatus({
        MProduct: extractedData.MProduct || false,
        MCatalogue: extractedData.MCatalogue || false,
        MCollection: extractedData.MCollection || false,
        MEmarketing: extractedData.MEmarketing || false,
        MQuotation: extractedData.MQuotation || false,
        MBuyer: extractedData.MBuyer || false,
        PMaster: extractedData.PMaster || false,
        MSTCategory: extractedData.MSTCategory || false,
        MSTPType: extractedData.MSTPType || false,
        MSTCollection: extractedData.MSTCollection || false,
        MSTFinish: extractedData.MSTFinish || false,
        MSTColor: extractedData.MSTColor || false,
        MSTHSN: extractedData.MSTHSN || false,
        MSTShape: extractedData.MSTShape || false,
        MSTPTechnique: extractedData.MSTPTechnique || false,
        MSTProcess: extractedData.MSTProcess || false,
        MSTMaterial: extractedData.MSTMaterial || false,
        PRDView: extractedData.PRDView || false,
        PRDAdd: extractedData.PRDAdd || false,
        PRDManage: extractedData.PRDManage || false,
        PRDEdit: extractedData.PRDEdit || false,
        PRDDelete: extractedData.PRDDelete || false,
        PRDpicdwnld: extractedData.PRDpicdwnld || false,
        CATcreate: extractedData.CATcreate || false,
        CATupdate: extractedData.CATupdate || false,
        CATaccessPPT: extractedData.CATaccessPPT || false,
        CATLinkSecurity: extractedData.CATLinkSecurity || false,
        CATShwPrice: extractedData.CATShwPrice || false,
        CATCustomizeTab: extractedData.CATCustomizeTab || false,
        CATModifySts: extractedData.CATModifySts || false,
        CATBuyerAct: extractedData.CATBuyerAct || false,
        CATControlSet: extractedData.CATControlSet || false,
        CATDelete: extractedData.CATDelete || false,
        MSpaceV: extractedData.MSpaceV || false,
        MFair: extractedData.MFair || false,
        MEnquiry: extractedData.MEnquiry || false,
        MGreeting: extractedData.MGreeting || false,
        PriceList: extractedData.PriceList || false,
        MSTSeason: extractedData.MSTSeason || false,
        MSTCosHead: extractedData.MSTCosHead || false,
        MSTCurrency: extractedData.MSTCurrency || false,
        MSTComponent: extractedData.MSTComponent || false,
        PRDCostShow: extractedData.PRDCostShow || false,
        Authorised: extractedData.Authorised || false,
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleControls = async key => {
    try {
      const updatedStatus = !status[key]; // Toggle the status
      await updateControls(key, updatedStatus);
      fetchData();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  const updateControls = async (key, newStatus) => {
    try {
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          [key]: newStatus
        })
      );
      await fetch(`${ip}/api/user-details/${data}`, {
        method: 'PUT',
        body: formData
      });
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  return (
    <Modal backdrop="static" open={true} onClose={onClose} size="lg">
      <Modal.Header>
        <Modal.Title>
          <b>User Permissions</b>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ marginBottom: '10px' }}>
          Add users to the platform and define their permissions of usage
        </p>
        <Stack alignItems="flex-start">
          <Nav
            appearance="subtle"
            activeKey={activeKey}
            onSelect={handleNavSelect}
            style={{ width: 200, gap: '50px' }}
            vertical
          >
            <Nav.Item eventKey="content1">
              <b>Menu Access</b>
            </Nav.Item>
            <Nav.Item eventKey="content2">
              <b>User Controls</b>
            </Nav.Item>
          </Nav>
          <Divider vertical style={{ height: '35em' }} />
          {activeKey === 'content1' && (
            <PanelGroup style={{ height: '62vh', overflowY: 'scroll', width: '500px' }}>
              <Panel>
                <Stack spacing={10} alignItems="flex-start">
                  <Toggle checked={status.MProduct} onChange={() => handleControls('MProduct')} />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Manage Products</b>
                    <p>You can manage products</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10} alignItems="flex-start">
                  <Toggle
                    checked={status.MCatalogue}
                    onChange={() => handleControls('MCatalogue')}
                  />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Manage Cataloues</b>
                    <p>You can manage Cataloues</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10} alignItems="flex-start">
                  <Toggle
                    checked={status.MCollection}
                    onChange={() => handleControls('MCollection')}
                  />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Collections</b>
                    <p>You can view Collections</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10} alignItems="flex-start">
                  <Toggle
                    checked={status.MEmarketing}
                    onChange={() => handleControls('MEmarketing')}
                  />
                  <Stack direction="column" alignItems="flex-start">
                    <b>E-Marketing</b>
                    <p>You can Manage E-Marketing</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10} alignItems="flex-start">
                  <Toggle
                    checked={status.MQuotation}
                    onChange={() => handleControls('MQuotation')}
                  />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Manage Quatation</b>
                    <p>You can Manage Quatation</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10} alignItems="flex-start">
                  <Toggle checked={status.MBuyer} onChange={() => handleControls('MBuyer')} />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Manage Buyer</b>
                    <p>You can Manage Buyer</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10}>
                  <Toggle checked={status.PMaster} onChange={() => handleControls('PMaster')} />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Product Masters</b>
                    <p>You can Manage Product Masters</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10}>
                  <Toggle checked={status.MSpaceV} onChange={() => handleControls('MSpaceV')} />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Space Visualization</b>
                    <p>You can Access Space Visualization</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10}>
                  <Toggle checked={status.MFair} onChange={() => handleControls('MFair')} />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Manage Fair</b>
                    <p>You can Manage Fair</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10}>
                  <Toggle checked={status.MEnquiry} onChange={() => handleControls('MEnquiry')} />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Manage Enquiry</b>
                    <p>You can Manage Enquiry</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10}>
                  <Toggle checked={status.MGreeting} onChange={() => handleControls('MGreeting')} />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Manage Greeting</b>
                    <p>You can Manage Greeting</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10}>
                  <Toggle checked={status.PriceList} onChange={() => handleControls('PriceList')} />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Price Listing</b>
                    <p>You can Manage Price</p>
                  </Stack>
                </Stack>
              </Panel>
              <Panel>
                <Stack spacing={10}>
                  <Toggle checked={status.Authorised} onChange={() => handleControls('Authorised')} />
                  <Stack direction="column" alignItems="flex-start">
                    <b>Authorization</b>
                    <p>You can give access to Authorize Product</p>
                  </Stack>
                </Stack>
              </Panel>
            </PanelGroup>
          )}
          {activeKey === 'content2' && (
            <>
              <Nav
                appearance="tabs"
                activeKey={activeKey1}
                onSelect={handleNavSelect1}
                style={{ gap: '50px' }}
              >
                {status.MProduct && (
                  <Nav.Item eventKey="sub1">
                    <b>Products</b>
                  </Nav.Item>
                )}
                {status.MCatalogue && (
                  <Nav.Item eventKey="sub2">
                    <b>Catalogues</b>
                  </Nav.Item>
                )}
                {status.MCollection && (
                  <Nav.Item eventKey="sub3">
                    <b>Collections</b>
                  </Nav.Item>
                )}
                {status.MEmarketing && (
                  <Nav.Item eventKey="sub4">
                    <b>E-marketing</b>
                  </Nav.Item>
                )}
                {status.MBuyer && (
                  <Nav.Item eventKey="sub5">
                    <b>Manage Buyer</b>
                  </Nav.Item>
                )}
                {status.PMaster && (
                  <Nav.Item eventKey="sub6">
                    <b>Masters</b>
                  </Nav.Item>
                )}
              </Nav>
              {activeKey1 === 'sub1' && (
                <>
                  <PanelGroup>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.PRDView}
                          onChange={() => handleControls('PRDView')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>View Products</b>
                          <p>User can View Products</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle checked={status.PRDAdd} onChange={() => handleControls('PRDAdd')} />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Add New Products</b>
                          <p>User can create a new category of products</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.PRDManage}
                          onChange={() => handleControls('PRDManage')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Manage Products</b>
                          <p>User can Manage Products</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.PRDEdit}
                          onChange={() => handleControls('PRDEdit')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Edit product Details</b>
                          <p>User can edit the details od selected fields only</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.PRDpicdwnld}
                          onChange={() => handleControls('PRDpicdwnld')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Download Product Pictures</b>
                          <p>User can download pictures of any product</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.PRDDelete}
                          onChange={() => handleControls('PRDDelete')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Delete Products</b>
                          <p>User can delete products from the platfrom</p>
                        </Stack>
                      </Stack>
                    </Panel>
                  </PanelGroup>
                </>
              )}
              {activeKey1 === 'sub2' && (
                <>
                  <PanelGroup style={{ height: '58vh', overflowY: 'scroll' }}>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.CATcreate}
                          onChange={() => handleControls('CATcreate')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Create and edit Catalogues</b>
                          <p>User can create new catalogues and edit their details</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.CATaccessPPT}
                          onChange={() => handleControls('CATaccessPPT')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Access to PPT, Excel, PDF and Catalogue Link</b>
                          <p>User can view catalogue link and download PPT, Excel, PDF</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.CATLinkSecurity}
                          onChange={() => handleControls('CATLinkSecurity')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Update link security settings</b>
                          <p>User can update link security settings of catalogues</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.CATShwPrice}
                          onChange={() => handleControls('CATShwPrice')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Show Pricing</b>
                          <p>User can show prices of products</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.CATCustomizeTab}
                          onChange={() => handleControls('CATCustomizeTab')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Customize Table</b>
                          <p>User can Customize of catalogues</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.CATupdate}
                          onChange={() => handleControls('CATupdate')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Update Catalogue Products</b>
                          <p>User can Update catalogue products</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.CATModifySts}
                          onChange={() => handleControls('CATModifySts')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Modify Statue</b>
                          <p>User can Change catalogue status</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.CATBuyerAct}
                          onChange={() => handleControls('CATBuyerAct')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Show Buyer Activity</b>
                          <p>User can view buyer activity</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.CATControlSet}
                          onChange={() => handleControls('CATControlSet')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Catalogue Setting</b>
                          <p>User can customize catalogue settings</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.CATDelete}
                          onChange={() => handleControls('CATDelete')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Delete Catalogues</b>
                          <p>User can delete any catalogues</p>
                        </Stack>
                      </Stack>
                    </Panel>
                  </PanelGroup>
                </>
              )}
              {activeKey1 === 'sub3' && <></>}
              {activeKey1 === 'sub4' && <></>}
              {activeKey1 === 'sub5' && <></>}
              {activeKey1 === 'sub6' && (
                <>
                  <PanelGroup style={{ height: '58vh', overflowY: 'scroll' }}>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTCategory}
                          onChange={() => handleControls('MSTCategory')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.Category}</b>
                          <p>User can Manage {label[0]?.attributes.Category}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTPType}
                          onChange={() => handleControls('MSTPType')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.ProductType}</b>
                          <p>User can Manage {label[0]?.attributes.ProductType}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTCollection}
                          onChange={() => handleControls('MSTCollection')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.Collection}</b>
                          <p>User can Manage {label[0]?.attributes.Collection}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTFinish}
                          onChange={() => handleControls('MSTFinish')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.finish}</b>
                          <p>User can Manage {label[0]?.attributes.finish}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTColor}
                          onChange={() => handleControls('MSTColor')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.color}</b>
                          <p>User can Manage {label[0]?.attributes.color}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle checked={status.MSTHSN} onChange={() => handleControls('MSTHSN')} />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.HSN}</b>
                          <p>User can Manage {label[0]?.attributes.HSN}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTShape}
                          onChange={() => handleControls('MSTShape')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.Shape}</b>
                          <p>User can Manage {label[0]?.attributes.Shape}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTPTechnique}
                          onChange={() => handleControls('MSTPTechnique')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.P_Technique}</b>
                          <p>User can Manage {label[0]?.attributes.P_Technique}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTProcess}
                          onChange={() => handleControls('MSTProcess')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.Season}</b>
                          <p>User can change {label[0]?.attributes.Season}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTMaterial}
                          onChange={() => handleControls('MSTMaterial')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.MaterialName}</b>
                          <p>User can Manage {label[0]?.attributes.MaterialName}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTSeason}
                          onChange={() => handleControls('MSTSeason')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.Season}</b>
                          <p>User can Manage {label[0]?.attributes.Season}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTCosHead}
                          onChange={() => handleControls('MSTCosHead')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Costing Head</b>
                          <p>User can Manage Costing Head</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTCurrency}
                          onChange={() => handleControls('MSTCurrency')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.Currency}</b>
                          <p>User can Manage {label[0]?.attributes.Currency}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.MSTComponent}
                          onChange={() => handleControls('MSTComponent')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>{label[0]?.attributes.Component}</b>
                          <p>User can Manage {label[0]?.attributes.Component}</p>
                        </Stack>
                      </Stack>
                    </Panel>
                    <Panel>
                      <Stack spacing={10} alignItems="flex-start">
                        <Toggle
                          checked={status.PRDCostShow}
                          onChange={() => handleControls('PRDCostShow')}
                        />
                        <Stack direction="column" alignItems="flex-start">
                          <b>Cost Show on Products</b>
                          <p>User can Manage Cost</p>
                        </Stack>
                      </Stack>
                    </Panel>
                  </PanelGroup>
                </>
              )}
            </>
          )}
          {activeKey === 'content3' && (
            <>
              <ErrorPage code={503}>
                <p className="error-page-title">Work In Progress...</p>
                <p className="error-page-subtitle text-muted ">
                  This page is being updating and maintainance.
                </p>
              </ErrorPage>
            </>
          )}
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <Button appearance="primary" color="cyan" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default YourModal;
